import { PortalManager } from "@chakra-ui/portal";
import { Tooltip } from "@chakra-ui/tooltip";
const TooltipHorizon = (props: {
  extra: string;
  trigger: JSX.Element;
  content: JSX.Element;
  placement: "left" | "right" | "top" | "bottom";
}) => {
  const { extra, trigger, content, placement } = props;
  return (
    <PortalManager zIndex={2000}>
      <Tooltip
        placement={placement}
        label={content}
        shouldWrapChildren
        className={`z-50 flex w-max justify-center rounded-md bg-white px-3 py-1 text-txt-sm text-text-800 shadow-xl shadow-shadow-500 ${extra}`}
      >
        {trigger}
      </Tooltip>
    </PortalManager>
  );
};

export default TooltipHorizon;
